<overlay-loading-spinner-border *ngIf="isLoading()" [show]="isLoading" />
